import { render, staticRenderFns } from "./ModalTreatment.vue?vue&type=template&id=06cd7f0e"
import script from "./ModalTreatment.vue?vue&type=script&lang=js"
export * from "./ModalTreatment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports